import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35091cd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6 my-2" }

import { EquipoDTO } from "@/interfaces/Inscripcion";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { ClasificacionEquipo, Torneo } from "@/interfaces/Torneo";
import { ref, watch } from "vue";
import { generarClasificacionEquipos } from "@/utils/clasificacionEquipos";
import TablaClasificacionEquipos from "./TablaClasificacionEquipos.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabClasificacionEquipos',
  props: {
    tabClasificacion: {},
    activeTab: {},
    torneo: {},
    partidas: {},
    equipos: {},
    mostrarClasificacion: { type: Boolean, default: true }
  },
  emits: ["enviarClasificacion"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const clasificacionEquipos = ref<ClasificacionEquipo[]>([]);

watch(
  [() => props.equipos, () => props.partidas, () => props.torneo],
  ([equipos, partidas, torneo]) => {
    if ((equipos?.length ?? 0) > 0 && (partidas?.length ?? 0) > 0) {
      clasificacionEquipos.value = generarClasificacionEquipos({
        equipos: equipos ?? [],
        partidas: partidas ?? [],
        torneo: torneo,
      });
      emit("enviarClasificacion", clasificacionEquipos.value);
    } else {
      clasificacionEquipos.value = [];
    }
  },
  // deep: la gestión actualiza partidas in situ (partidas[i] = ...) al editar o validar
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window_item = _resolveComponent("v-window-item")!

  return (_openBlock(), _createBlock(_component_v_window_item, {
    value: _ctx.tabClasificacion,
    key: _ctx.tabClasificacion
  }, {
    default: _withCtx(() => [
      (_ctx.mostrarClasificacion !== false)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.torneo?.tipoTorneo === "Parejas"
            ? "Clasificación por Parejas"
            : "Clasificación por Equipos"), 1),
            _createVNode(TablaClasificacionEquipos, {
              clasificacion: clasificacionEquipos.value,
              esParejas: _ctx.torneo?.tipoTorneo === 'Parejas'
            }, null, 8, ["clasificacion", "esParejas"])
          ], 64))
        : (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            variant: "tonal",
            class: "ma-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode("La clasificación está oculta")
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})